import { FolderOpen } from 'lucide-react';
import type { FC } from 'react';

interface EmptyStateProps {
  title: string;
  message: string;
}

export const EmptyState: FC<EmptyStateProps> = ({ title, message }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
      <FolderOpen size={64} className="text-gray-300" />
      <div className="text-center">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-sm text-gray-500">{message}</p>
      </div>
    </div>
  );
};
